export default __webpack_public_path__ + "static/media/cielo-logo.fe1d4352.svg";